/**
 * Standaard boilerplate scripts
 */

var addListener = (element, type, callback) => {
    if (element.addEventListener) {
        element.addEventListener(type, callback);
    } else if (element.attachEvent) {
        element.attachEvent('on' + type, callback);
    }
};

/*/ cookiepage settings /*/
function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
}

(function () {
    var buttonAccept = document.getElementsByClassName('cookiesettings__card--accept')[0],
        buttonDecline = document.getElementsByClassName('cookiesettings__card--decline')[0];

    if (buttonAccept) {
        buttonAccept.onclick = function () {
            createCookie('cookieSet', true, 10000);
            location.reload();
        };

        buttonDecline.onclick = function () {
            createCookie('cookieSet', 'declined', 10000);
            location.reload();
        };
    }
})();

// menu
var menuOnLoad = () => {
    var ulHasChildren = document.getElementsByClassName('menu__list');
    for (var i = 0; i < ulHasChildren.length; i++) {
        if (ulHasChildren[i].childNodes.length === 2) {
            ulHasChildren[i].classList.add('has-children');
        }
    }

    var menuChildToggle = document.getElementsByClassName('has-children');
    for (let k = 0; k < menuChildToggle.length; k++) {
        menuChildToggle[k].addEventListener('click', function () {
            var menu = menuChildToggle[k].childNodes;
            if (menuChildToggle[k].classList) {
                menuChildToggle[k].classList.toggle('open-parent');
                menu[1].classList.toggle('open');
            }
        })
    }
};
if (window.attachEvent) {
    window.attachEvent('onload', menuOnLoad);
} else if (window.addEventListener) {
    window.addEventListener('load', menuOnLoad, false);
} else {
    document.addEventListener('load', menuOnLoad, false);
}

(() => {
    var isIE = /*@cc_on!@*/false || !!document.documentMode;
    var notificationIE = document.getElementsByClassName('notificationIE')[0];
    var exit = document.getElementsByClassName('notificationIE-exit')[0];
    if (isIE === true) {
        var exitIEFunction = () => notificationIE.parentNode.removeChild(notificationIE);
        notificationIE.classList.add('block');
        exit.onclick = () => exitIEFunction();
    } else {
        notificationIE.parentNode.removeChild(notificationIE);
    }
})();

(() => {
    var faqItem = document.getElementsByClassName('faq__item');
    for (let k = 0; k < faqItem.length; k++) {
        faqItem[k].addEventListener('click', () => {
            if (faqItem[k].classList) {
                faqItem[k].classList.toggle('active');
            }
        })
    }
})();

(() => {
    var showall = document.getElementsByClassName('show-all');
    for (let k = 0; k < showall.length; k++) {
        showall[k].addEventListener('click', () => {
            var parent = showall[k].parentNode;
            if (parent.classList) {
                parent.classList.toggle('active');
            }
        })
    }
})();

(() => {
    var tabLink = document.querySelectorAll("[data-tabLink]");
    var tabContent = document.querySelectorAll("[data-tabContent]");
    if (tabLink.length > 1) {
        for (let k = 0; k < tabLink.length; k++) {
            tabLink[k].addEventListener('click', () => {
                for (var l = 0; l < tabLink.length; l++) {
                    tabLink[l].classList.remove('active');
                }
                tabLink[k].classList.add('active');
                for (let i = 0; i < tabContent.length; i++) {
                    var tabLinkAttr = tabLink[k].getAttribute("data-tabLink");
                    var tabContentAttr = tabContent[i].getAttribute("data-tabContent");
                    tabContent[i].style.display = "none";
                    if (tabContentAttr === tabLinkAttr) {
                        tabContent[i].style.display = "flex";
                    }
                }
            });
        }
        document.querySelector("[data-defaultOpen]").click();
    }
})();

(() => {
    var aHref = document.querySelectorAll('a[href^="#"]');
    for (var k = 0; k < aHref.length; k++) {
        aHref[k].addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    }
})();


var isOutOfViewport = function (elem) {
    var bounding = elem.getBoundingClientRect();
    var out = {};
    out.top = bounding.top < 0;
    out.left = bounding.left < 0;
    out.bottom = bounding.top < (window.innerHeight || document.documentElement.clientHeight);
    out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
    out.any = out.top || out.left || out.bottom || out.right;
    return out;
};
var elem = document.getElementsByTagName('footer')[0];
var logViewport = function () {
    var isOut = isOutOfViewport(elem);
    if (!isOut.bottom) {
        document.getElementsByClassName('fixedWhatsapp')[0].classList.add('fixedWhatsapp--active');
    } else {
        document.getElementsByClassName('fixedWhatsapp')[0].classList.remove('fixedWhatsapp--active');
    }
};
logViewport();
window.addEventListener('scroll', logViewport, false);


(() => {
    if (document.getElementById('bodAanvraagPage')) {
        document.getElementsByClassName('bodAanvraag')[0].scrollIntoView({
            behavior: 'smooth'
        });
    }
})();


window.addEventListener("scroll", (event) => {
    const credits = document.querySelector("#creditsNiice");
    if (window.innerWidth < 768) {
        if (credits.getBoundingClientRect().bottom < (window.innerHeight || document.documentElement.clientHeight)) {
            credits.classList.add("visible-credits");
        } else {
            credits.classList.remove("visible-credits");
        }
    } else {
        credits.classList.remove("visible-credits");
    }
});
